import useFCSubscriptionStore from "@hsl/fc-subscription/store";

import { FlowStepper } from "./FlowStepper";

export const SubscribeFlow = () => {
    const user = useFCSubscriptionStore((state) => state.user);

    if (user) {
        return (
            <FlowStepper
                steps={["select-funds", "select-documents"]}
                defaultStep="select-documents"
                finalStepMode="submit"
                type="subscribe"
            />
        );
    }

    return (
        <FlowStepper
            steps={[
                "select-funds",
                "select-documents",
                "add-details",
                "verify-email",
            ]}
            defaultStep="select-documents"
            finalStepMode="hide"
            type="subscribe"
        />
    );
};
